import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overlay", "panel", "content"];

  show(event) {
    const row = event.currentTarget.closest("tr");
    const data = JSON.parse(row.dataset.conversionEventDetail);

    this.contentTarget.innerHTML = this._buildDetail(data);
    this.overlayTarget.classList.remove("hidden");
    this.panelTarget.classList.remove("translate-x-full");
  }

  close() {
    this.panelTarget.classList.add("translate-x-full");
    this.overlayTarget.classList.add("hidden");
  }

  // Private

  _buildDetail(d) {
    const rows = [
      ["Date", d.date],
      ["Event ID", d.event_id],
      ["Event Name", d.event_name],
      ["User", d.user],
      ["Restaurant", d.restaurant],
      ["IP Address", d.ip_address],
      ["User Agent", d.user_agent],
      ["gclid", d.gclid],
      ["fbc", d.fbc],
      ["fbp", d.fbp],
      ["Phone Hash", d.phone_hash],
      ["Sent to Google", d.sent_to_google ? "Yes" : "No"],
      ["Sent to Meta", d.sent_to_meta ? "Yes" : "No"],
    ];

    const tableRows = rows
      .map(([label, value]) => {
        const display = value || "-";
        return `<tr>
          <td class="text-base-content/60 whitespace-nowrap">${label}</td>
          <td class="text-right font-mono text-xs break-all">${this._escapeHtml(String(display))}</td>
        </tr>`;
      })
      .join("");

    let metadataHtml = "";
    if (d.metadata && Object.keys(d.metadata).length > 0) {
      metadataHtml = `
        <div class="mt-4">
          <h3 class="text-sm font-semibold mb-2">Metadata</h3>
          <pre class="bg-base-300 rounded-lg p-3 text-xs overflow-x-auto">${this._escapeHtml(JSON.stringify(d.metadata, null, 2))}</pre>
        </div>`;
    }

    return `<table class="table table-md"><tbody>${tableRows}</tbody></table>${metadataHtml}`;
  }

  _escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
